import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { cDataService } from 'src/app/services/data.service';
import * as prompts from './structured.json';
import * as CodeMirror from 'codemirror';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-edit-prompts',
  templateUrl: './edit-prompts.component.html',
  styleUrls: ['./edit-prompts.component.scss']
})
export class EditPromptsComponent implements OnInit {
  selectedRowIndex: number = 0;
  @Output() closeModal = new EventEmitter<MouseEvent>();
  activeDisplayName: any;
  promptActivation: any;
  structuredPrompt: any
  selectedPromptRowIndex: any;
  editingValue: string;
  editingKey: string = '';
  hoveredRowIndex: number = -1;
  modalRef!: NgbModalRef;
  @ViewChild('jsonEditorModal') jsonEditorModal!: ElementRef;
  jsonData: any;
  checkeditorSpecs: any;
  selectedItem: any;
  updateChildKey: boolean = false;
  formGroup: FormGroup;
  private addSubNodeHandler = () => this.addsubNode();
  codemirrorEditors: CodeMirror.EditorFromTextArea[] = []; // Add this property
  currentIndex = 0;
  isEditingKey: boolean = false;
  editedKey: string = '';
  parentNode: boolean = false;
  JsonModeFromEditorSpecs : boolean = false;
  EditorSpecsJSON : any;
  newChangesCreated : boolean = false;
  originalContentJSON : any;
  originalEditorSpecsJson : any;
  discardModalRef: NgbModalRef | null = null;
  constructor(
    private oDataService: cDataService,
    private modalService: NgbModal

  ) {
    // (window as any).handleInputChange = this.handleInputChange.bind(this);
  }
  bResponseAlert: boolean;
  resMessage: { message: any; responseType: any; color: any };
  bLoading: boolean = true;
  hoveredChild: any = null;
  @Input() file
  @Input() completeWorkFlowList
  codeMirrorOptions: any = {
    mode: "application/json",
    indentWithTabs: true,
    smartIndent: true,
    lineNumbers: true,
    lineWrapping: true,
    extraKeys: { "Ctrl-Space": "autocomplete", "Ctrl-Q": function (cm) { cm.foldCode(cm.getCursor()); } },
    foldGutter: true,
    gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter", "CodeMirror-lint-markers"],
    autoCloseBrackets: true,
    matchBrackets: true,
    lint: true,
    autoFocus: true,
        theme:'idea'
  };
  promptsList: any = []
  json: any
  formHtml: any;
  parentItem: any;
  formData: any;
  @ViewChild('formContainer') formContainer!: ElementRef;
  @ViewChild('codemirror', { static: false }) codemirror: any;
  @ViewChildren('resizableTextarea') resizableTextareas: QueryList<ElementRef>;

  // ****************************************** ngOnInit ***************************************

  ngOnInit() {
    this.selectedPromptRowIndex = 0
    this.getPromptsList();
  }



  // --------------------getPromptsList  --------------------

  getPromptsList(action?: string, check?: boolean) {
    const parentId = this.completeWorkFlowList?.id;
    const name = this.file.activityName;

    this.oDataService.DataService_GetPromptsList(parentId, name).subscribe({
      next: (res) => {
        this.bLoading = false;

        if (res.failed) {
          this.displayAlertMessage(res.message, "failed", "danger");
          return;
        }

        this.promptsList = res;
        if(this.promptsList[0]?.editorSpecs && this.promptsList[0]?.content){
          this.codeMirrorOptions.mode='application/json'
        }
        else{
          this.codeMirrorOptions.mode="plain/text"
        }
        if (!check) {
          let index = this.promptsList.findIndex(p => p.active);
          if (index === -1) {
            console.warn('No active prompt found. Defaulting to index 0.');
            index = 0;
          }
          this.setExtractedPropmtSetup(this.promptsList[index], index)
          this.setActivePromptByIndex(index);
        }
        // If called after saving a new prompt
        if (action === "saveNew") {

        }
      },

      error: (error) => {
        this.displayAlertMessage(error.message || "An error occurred", "failed", "danger");
        this.bLoading = false;
      },

      complete: () => {
        console.log("Request complete");
      },
    });
  }

  setExtractedPropmtSetup(prompt, index) {
    console.log(prompt);
    
    if (prompt?.editorSpecs) {
      this.checkeditorSpecs = prompt;
      this.selectedItem = prompt.editorSpecs[0];
      this.structuredPrompt = prompt.editorSpecs;
      this.activeDisplayName = prompt.displayName;
      setTimeout(() => this.initializeResizeableTextareas());
      this.formData = this.structuredPrompt[0];
    }
  }

  setActivePromptByIndex(index: number) {
    this.selectedRowIndex = index;
    this.json = this.promptsList[this.selectedRowIndex]?.content;
    this.originalContentJSON = JSON.parse(JSON.stringify(this.promptsList[this.selectedRowIndex]?.content));
    if(this.promptsList[this.selectedRowIndex]?.editorSpecs)this.originalEditorSpecsJson = JSON.parse(JSON.stringify(this.promptsList[this.selectedRowIndex]?.editorSpecs));
    this.activeDisplayName = this.promptsList[this.selectedRowIndex]?.displayName
    // Update active prompt in your backend if needed
    this.selectedRowIndex = index;
    this.checkeditorSpecs = this.promptsList[this.selectedRowIndex]
    this.selectedPromptRowIndex = 0
  }

  trackByIndex(index: number): number {
    return index;
  }

  // -------------------- Add/Remove Item in StringList --------------------

  addItem() {
    this.formData.value.push('');
    this.newChangesCreated=true;
    setTimeout(() => this.initializeResizeableTextareas());
  }

  removeItem(index: number): void {
    this.formData.value.splice(index, 1);
    this.newChangesCreated=true;
  }

  // -------------------- Text Area Resize --------------------

  initializeResizeableTextareas() {
    if (this.resizableTextareas) {
      this.resizableTextareas.forEach(textareaRef => {
        const textarea = textareaRef.nativeElement;
        this.adjustTextareaHeight(textarea);
        textarea.addEventListener('input', () => {
          this.adjustTextareaHeight(textarea);
        });
      });
    }
  }

  adjustTextareaHeight(textarea: HTMLTextAreaElement) {
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }

  // --------------------savePrompt --------------------

  savePrompts(action: string) {
    // Initialize the payload with common properties
    let body: any = {
      parentId: this.completeWorkFlowList?.id,
      name: this.file.activityName,
      workflowType: this.completeWorkFlowList?.workflowType,
      content: this.json,
    };
    if (this.checkeditorSpecs?.content && this.checkeditorSpecs?.editorSpecs) {
      body.editorSpecs = this.promptsList[this.selectedRowIndex]?.editorSpecs
    }
    if(this.JsonModeFromEditorSpecs)
      {
        body.mode = 'json'
      }
    // Add or remove `id` based on the action
    if (action === 'save') {
      body.id = this.promptsList[this.selectedRowIndex]?.id,
        body.active = this.promptsList[this.selectedRowIndex]?.active

    }
    this.oDataService.DataService_savePropmt(body)
      .subscribe({
        next: (res) => {
          if (res.failed) {
            this.displayAlertMessage(res.message, "failed", "danger");
          } else {
            // this.json = res?.content;
            // this.originalContentJSON  = res?.content;
            // if(res?.editorSpecs)
            //   {
            //     this.originalEditorSpecsJson = res?.editorSpecs;
            //     this.promptsList[this.selectedRowIndex].editorSpecs = res?.editorSpecs;
            //     this.promptsList[this.selectedRowIndex].content = res?.content;
            //     this.structuredPrompt = res?.editorSpecs;
                
            //   }
            this.getPromptsList(undefined, false)
            this.newChangesCreated = false;
              if (this.discardModalRef) {
                  this.discardModalRef.close();
              }
            this.displayAlertMessage("Prompt saved successfully", "success", "success");
          }
        },
        error: (error) => {
          this.displayAlertMessage(error.message || "An error occurred", "failed", "danger");
        },
        complete: () => {
          console.log("Request complete");
        },
      });
  }

  // --------------------activatePrompt --------------------

  activatePrompt(item) {
    if (item.active == 1 || item.active === true) {
      return; // already active, no need to send request
    }
    let body = {
      id: item.id
    }
    this.oDataService.DataService_ActivatePrompt(body)
      .subscribe({
        next: (res) => {
          if (res.failed) {
            this.displayAlertMessage(res.message, "failed", "danger");
          } else {
            this.displayAlertMessage(res.message, "success", "success");
            this.getPromptsList(undefined, true)
          }
        },
        error: (error) => {
          this.displayAlertMessage(error.message || "An error occurred", "failed", "danger");
        },
        complete: () => {
          console.log("Request complete");
        },
      });
  }
  getPromptData(item: any, index: any) {
    if(this.promptsList[index].editorSpecs && this.promptsList[index].content){
      this.codeMirrorOptions.mode='application/ld+json'
    }else{
      this.codeMirrorOptions.mode="plain/text"
    }
    
    setTimeout(() => {
      this.initializeResizeableTextareas();
    });
    this.selectedRowIndex = index;
    this.json = this.promptsList[this.selectedRowIndex]?.content;
    this.originalContentJSON = this.promptsList[this.selectedRowIndex]?.content;
    this.originalEditorSpecsJson = JSON.parse(JSON.stringify(this.promptsList[this.selectedRowIndex]?.editorSpecs));
    this.activeDisplayName = item?.displayName
    this.promptActivation = item?.active
    this.checkeditorSpecs = item
    this.selectedPromptRowIndex = 0
    if (item.editorSpecs) {
      this.collapseAllNodes(item.editorSpecs);
      this.selectedItem = item.editorSpecs[0];
      this.structuredPrompt = item.editorSpecs;
      this.formData = item.editorSpecs[0];
    }


  }

  collapseAllNodes(nodes: any[]) {
    nodes.forEach(node => {
      node.expand = false;
    });
  }

  onClose() {
    this.closeModal.emit();
  }

  openVersionModal(version,discardModal) {
     if(this.newChangesCreated)
      {
       this.discardModalRef = this.modalService.open(discardModal, { centered: true, size: 'md', backdrop: 'static' });
      }
      else
      {
        this.modalService.open(version, { centered: true, size: 'md', backdrop: 'static' });
      }
  }

  // ****************************************** Structured prompt editor  ***************************************

  closeJsonModal() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }
  capitalizeFirstLetter(text: string): string {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  handleClick(child: any, index: string) {
       this.codeMirrorOptions.mode='application/ld+json'
    this.selectPromptItem(child, index, true, false);

  }

  // ********************************** Sidebar Node Selection  **********************************
  selectPromptItem(item: any, index: any, check: boolean, deletion: boolean) {
    let node;
    console.log(this.checkeditorSpecs);
    if (typeof index === 'string' && index.includes('-')) {
      const [parentIndex, childIndex] = index.split('-').map(Number);
      node = this.checkeditorSpecs.editorSpecs[parentIndex]?.children?.[childIndex];
    } else {
      node = this.checkeditorSpecs.editorSpecs[+index]; // convert to number in case it's a string
    }
    this.formData = node;
    setTimeout(() => {
      this.initializeResizeableTextareas();

    });
    const selectedIndexStr = this.selectedPromptRowIndex?.toString();
    if (!check && !deletion) {
      this.parentItem = item;
      this.promptsList[this.selectedRowIndex].editorSpecs[this.selectedPromptRowIndex] = this.selectedItem;
    }
    else if (selectedIndexStr?.includes('-') && check && !deletion) {
      let updatedData = JSON.parse(JSON.stringify(this.selectedItem))
      const [parentIndexStr, childIndexStr] = this.selectedPromptRowIndex.split('-');
      const parentIndex = parseInt(parentIndexStr, 10);
      const childIndex = parseInt(childIndexStr, 10);
      this.promptsList[this.selectedRowIndex].editorSpecs[parentIndex].children[childIndex] = updatedData;
    }
    item.expand = !item.expand;
    setTimeout(() => {
      this.updateChildKey = check;
      this.isEditingKey = false;
      this.selectedPromptRowIndex = index;
      this.selectedItem = item;
      setTimeout(() => {
        this.initializeResizeableTextareas();
      });
    }, 200);
  }

  addsubNode() {
    this.newChangesCreated = true;
    this.addDuplicateChild(this.selectedItem, this.selectedItem.children[this.selectedItem.children.length - 1], undefined, undefined)
  }

  // ***************************** Duplicate Node Creation  *******************************

  addDuplicateChild(parentItem: any, childItem: any, childIndex: number, event?: Event) {
    event?.stopPropagation();
    const duplicate = JSON.parse(JSON.stringify(childItem));
    const existingKeys = parentItem.children.map((c: any) => c.key);
    const baseKey = childItem.key.replace(/[0-9]*$/, '');
    let newKey = '';
    let counter = 1;
    do {
      newKey = `${baseKey}${counter}`;
      counter++;
    } while (existingKeys.includes(newKey));
    duplicate.key = newKey;
    if (childIndex != undefined) {
      parentItem.children.splice(childIndex + 1, 0, duplicate);
    }
    else {
      parentItem.children.push(duplicate);
    }
    this.newChangesCreated = true;
    this.updateStructuredPrompt(parentItem);
  }

  updateStructuredPrompt(updatedItem: any) {
    const index = this.structuredPrompt.findIndex(item => item.key === updatedItem.key);
    if (index !== -1) {
      this.structuredPrompt[index] = updatedItem;
    }
  }

  startEditingKey() {
    this.isEditingKey = true;
    this.editedKey = this.selectedItem?.key || '';
  }

  saveEditedKey() {
    const isDuplicate = this.parentItem.children
      .filter(child => child !== this.selectedItem)
      .some(child => child.key === this.editedKey);

    if (isDuplicate) {
      this.displayAlertMessage("Sub-Node name already exists.", 'danger', 'danger');
    } else {
      if (this.editedKey && this.selectedItem) {
        this.selectedItem.key = this.editedKey;
      }
      this.isEditingKey = false;
    }
  }

  // *************************** Remove Child Node  *********************
  removechild(event, parentItem, i, childIndex) {
    event?.stopPropagation();
    if (parentItem.children.length > 1) {
      parentItem.children.splice(childIndex, 1);
      const index = this.structuredPrompt.findIndex(item => item.key === parentItem.key);
      if (index !== -1) {
        this.structuredPrompt[index] = parentItem;
      }
      if (this.selectedPromptRowIndex === (i + '-' + childIndex)) {
        this.updateChildKey = false;
        this.newChangesCreated = true;
        this.selectPromptItem(parentItem, i, false, true);
        setTimeout(() => {
          this.selectPromptItem(parentItem, i, false, true);
        }, 100);
      }
    }
  }

  SwitchToJSONModeFromEditorSpecs(IncomingModal)
  {
     if(this.newChangesCreated)
      {
       this.discardModalRef =  this.modalService.open(IncomingModal, { centered: true, size: 'md', backdrop: 'static' });
      }
      else
      {
        this.JsonModeFromEditorSpecs= true;
      }
  }

  BackToStructredPrmptEditorSpecs(IncomingCase,IncomingModal)
  {
    if(this.newChangesCreated && IncomingCase == 'discard')
      {
       this.discardModalRef = this.modalService.open(IncomingModal, { centered: true, size: 'md', backdrop: 'static' });
      }
    else
    {
      this.json = JSON.parse(JSON.stringify(this.originalContentJSON));
      this.promptsList[this.selectedRowIndex].editorSpecs = JSON.parse(JSON.stringify(this.originalEditorSpecsJson));
      this.structuredPrompt = JSON.parse(JSON.stringify(this.originalEditorSpecsJson));
      this.formData = this.structuredPrompt[0];
      this.selectPromptItem(this.structuredPrompt[0], 0, false, false)
      this.JsonModeFromEditorSpecs = false;
      this.newChangesCreated = false;
      if (this.discardModalRef) {
          this.discardModalRef.close();
      }
    }
  }

  onModelChange(updatedValue)
  {
    this.newChangesCreated=true;
  }
  closeDiscardModal()
  {
     if (this.discardModalRef) {
          this.discardModalRef.close();
      }
  }

  // ****************************************** ALERT MESSAGES ***************************************

  displayAlertMessage(
    sIncommingMessage,
    sIncommingResponseType,
    sIncommingColor
  ) {
    this.bResponseAlert = true;
    this.resMessage = {
      message: sIncommingMessage,
      responseType: sIncommingResponseType,
      color: sIncommingColor,
    };
    setTimeout(() => {
      this.bResponseAlert = false;
    }, 3000);
  }
}
